import { ChangeEvent, ReactNode, RefCallback } from 'react'
import classNames from 'classnames/bind'

import styles from './plain-radio-button.module.scss';


const cx = classNames.bind(styles)

export type Props = {
  name: string
  value: string
  label: string | ReactNode
  hideLabel?: boolean // скрыт, но доступен для скрин-ридеров
  skipLabel?: boolean
  checked?: boolean
  id?: string
  disabled?: boolean
  className?: string
  reference?: RefCallback<HTMLInputElement>
  level?: number
  style?: object
  form?: string

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void,
  onFocus?: (e: ChangeEvent<HTMLInputElement>) => void,
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void,
}

const PlainRadioButton = ({
  name,
  value,
  label,
  hideLabel,
  skipLabel,
  checked,
  id,
  disabled,
  className,
  reference,
  level,
  style,
  form,

  onChange,
  onFocus,
  onBlur,
}: Props) => {
  const currentId = id || `${name}_${value}`

  const levelClassName = { [`level${level || ''}`]: level }
  const rootClassName = cx(styles.root, { disabled, hideLabel, ...levelClassName }, className)
  const checkboxClassName = cx(styles.circle, { disabled, skipLabel, hideLabel })
  const labelClassName = cx(styles.label, { hidden: hideLabel, disabled })

  const containerClassName = (
    skipLabel
      ? cx(styles.container, { skipLabel, ...levelClassName }, className)
      : cx(styles.container, { hideLabel })
  )

  const renderControl = (
    <span className={containerClassName}>
      <input
        id={currentId}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        className={styles.input}
        ref={reference}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        form={form}
      />

      <span className={checkboxClassName} />

      {label
        && !skipLabel
        && <span className={labelClassName}>
          {label}
        </span>}
    </span>
  )

  if (skipLabel) {
    return (
      renderControl
    )
  }

  return (
    <label // eslint-disable-line jsx-a11y/label-has-associated-control
      className={rootClassName}
      style={style}
    >
      {renderControl}
    </label>
  )
}

export default PlainRadioButton
